import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import CircleIcon from '@mui/icons-material/Circle';
import './GridView.scss';

export default function GridView({ books, onBookSelect }) {
    return (
        <Box className="grid-container">
            {books.map((book) => {
                const isAvailable = book.isAvailable === true;

                return (
                    <Paper
                        key={book.id}
                        className="book-card"
                        elevation={1}
                        onClick={() => onBookSelect && onBookSelect(book)}
                        sx={{ cursor: onBookSelect ? 'pointer' : 'default' }}
                    >
                        {book.cover ? (
                            <img
                                src={book.cover} //the ".cover" field is not currently being provided by the Salesforce API. it will also need to be changed to the correct varible
                                alt={book.title}
                                className="book-cover"
                                loading="lazy"
                            />
                        ) : (
                            // NEEDS TO BE Fixed:
                            // Salesforce/API does not currently provide cover field
                            // This keeps the existing layout without using demo book-cover data hopefully.
                        
                            <div className="book-cover">
                                No Cover
                            </div>
                        )}

                        <div className="card-content">
                            <div className="text-wrapper">
                                <Typography
                                    variant="subtitle1"
                                    component="h3"
                                    className="book-title"
                                >
                                    {book.title}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    className="book-author"
                                >
                                    {book.author}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    className="book-genre"
                                >
                                    {book.genre}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    className="book-published"
                                >
                                    {book.Published}
                                </Typography>
                            </div>

                            <Box sx={{ alignSelf: 'flex-start', mt: 1 }}>
                                <Chip
                                    icon={
                                        isAvailable
                                            ? <CircleIcon sx={{ fontSize: '10px !important' }} />
                                            : undefined
                                    }
                                    label={
                                        isAvailable
                                            ? 'Available'
                                            : 'Checked Out'
                                    }
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '0.75rem',
                                        backgroundColor: isAvailable ? '#d3f0d4' : '#f4f4f4',
                                        color: isAvailable ? 'success.main' : 'error.main',
                                        borderColor: isAvailable ? '#d3f0d4' : '#f4f4f4',
                                        borderWidth: '1px',
                                        borderStyle: 'solid',
                                        '& .MuiChip-icon': {
                                            color: isAvailable ? 'success.main' : 'error.main',
                                            ml: '6px',
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </Paper>
                );
            })}
        </Box>
    );
}